export const ROUTH_PATH = {
  home: '/',
  login: '/login',
  unauthorized: '/unauthorized',
};
